import { Row } from 'antd'

import type { OrganizationLong } from 'src/api/main'

import { OrganizationItem } from './OrganizationItem'

type Props = {
  filteredOrganizations?: OrganizationLong[]
}

export const OrganizationList = ({ filteredOrganizations }: Props) => {
  return (
    <Row gutter={[16, 16]} className="w-full" style={{ marginInline: 0 }}>
      {filteredOrganizations?.map((app) => (
        <OrganizationItem key={app.id} item={app} />
      ))}
    </Row>
  )
}
